import { useQuery } from '@apollo/client';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import VftViewer from '~/components/virtualFieldTrip/vft-viewer';
import { useRouteParam } from '~/hooks/routing';

const OUTCROP_TOUR_PAGE = graphql(`
  query OutcropTourDetailPage($vftId: ID!) {
    virtualFieldTripGet(id: $vftId) {
      id
      name
    }
  }
`);

export default function OutcropTourDetailPage() {
  const vftId = useRouteParam('vftId', parseInt);

  const { data, loading } = useQuery(OUTCROP_TOUR_PAGE, {
    variables: { vftId: vftId },
  });

  const vft = data?.virtualFieldTripGet;

  if (loading) return <SpinnerPlaceholder />;
  if (!vft) return <NotFound />;

  return <VftViewer id={vft.id} />
}
